function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#596266",
  d: "M8,2.00151765 C11.3137085,2.00151765 14,4.69052706 14,8.00758826 C14,9.5387685 13.4276011,10.9361225 12.4853141,11.9969346 L11.7767384,11.287642 C12.5387572,10.4092149 13,9.26232057 13,8.00758826 C13,5.24337059 10.7614237,3.00252942 8,3.00252942 L8,4.50404707 L5,2.50202354 L8,0.5 L8,2.00151765 Z M8,13.9984823 C4.6862915,13.9984823 2,11.3094729 2,7.99241174 C2,6.4612315 2.57239891,5.06387746 3.51468585,4.00306538 L4.22326155,4.712358 C3.46124278,5.59078513 3,6.73767943 3,7.99241174 C3,10.7566294 5.23857625,12.9974706 8,12.9974706 L8,11.4959529 L11,13.4979765 L8,15.5 L8,13.9984823 Z"
});

var SvgUpdate = function SvgUpdate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpdate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Update.79227b88.svg";
export { ForwardRef as ReactComponent };